// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['edit', 'form']

  change(event) {
    this.formTarget.requestSubmit()
    // 'hidden' — every render site is civic as of P2d (was Bootstrap d-none)
    this.editTarget.classList.add('hidden');
  }
}
